import {
  SHOW_ACTIVITY,
  SET_ACTIVITY_FILTER,
  TOGGLE_SIDEBAR,
  HIDE_SIDEBAR
} from '../actionTypes'
import ReactGA from 'react-ga'
import { firebaseAction } from '../utils'
import firebase from 'firebase/app'

const timestamp = firebase.database.ServerValue.TIMESTAMP

export const toggleActivity = show => {
  if (show !== true && show !== false) show = undefined
  return {
    type: SHOW_ACTIVITY,
    payload: { show }
  }
}

export const setActivityFilter = filter => {
  return {
    type: SET_ACTIVITY_FILTER,
    payload: { filter }
  }
}

export const markActivityRead = activityId =>
  firebaseAction((update, { dispatch, getAuth }) => {
    const path = `/activity/feeds/${getAuth().uid}/feed/${activityId}/read`
    const forward = { [path]: timestamp }
    const backward = { [path]: null }
    update({ forward, backward })
  })

export const activityReducer = (
  state = {
    show: false,
    filter: localStorage.getItem('activityFilter') || 'all'
  },
  { type, payload }
) => {
  switch (type) {
    case SHOW_ACTIVITY:
      const { show = !state.show } = payload
      if (show)
        ReactGA.event(
          {
            category: 'Activity',
            action: 'Show Activity'
          },
          ['app']
        )
      return { ...state, show: show }
    case TOGGLE_SIDEBAR:
    case HIDE_SIDEBAR:
      return { ...state, show: false }
    case SET_ACTIVITY_FILTER:
      localStorage.setItem('activityFilter', payload.filter)
      ReactGA.event(
        {
          category: 'Activity',
          action: 'Set Filter',
          label: payload.filter
        },
        ['app']
      )
      return { ...state, filter: payload.filter }
    default:
      return state
  }
}
